import React, { useMemo } from "react";
import clientLogo1 from "../assets/images/client logo1.png";
import clientLogo2 from "../assets/images/client logo2.png";
import clientLogo3 from "../assets/images/client logo3.png";
import clientLogo4 from "../assets/images/client logo4.png";
import clientLogo5 from "../assets/images/client logo5.png";
import "./OurClients.css";

const clientLogos = [
  {
    id: "dicci",
    name: "DICCI",
    logo: clientLogo1,
  },
  {
    id: "motherson",
    name: "Motherson",
    logo: clientLogo2,
  },
  {
    id: "greenfuel",
    name: "GreenFuel Technology",
    logo: clientLogo3,
  },
  {
    id: "sagar",
    name: "Sagar Consultancy",
    logo: clientLogo4,
  },
  {
    id: "hemantra",
    name: "Hemantra",
    logo: clientLogo5,
  },
];

const OurClients = () => {
  // Duplicate the 5 logos 4 times (20 items total).
  // Translating -50% shifts exactly 2 full sets (10 items),
  // creating a mathematically seamless, infinite continuous loop with zero jumps or blank frames.
  const marqueeItems = useMemo(
    () => [...clientLogos, ...clientLogos, ...clientLogos, ...clientLogos],
    []
  );

  return (
    <section
      aria-label="Trusted by Our Clients"
      className="relative overflow-hidden py-5 sm:py-6 border-y border-white/[0.06]"
      style={{ background: "#060B1F" }}
    >
      {/* Subtle background tech grid */}
      <div className="absolute inset-0 tech-grid opacity-10 pointer-events-none" />

      {/* Subtle Heading */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-3 sm:mb-4 text-center">
        <p
          className="text-xs font-semibold tracking-[0.2em] text-slate-400 uppercase"
          style={{ fontFamily: '"Space Grotesk", sans-serif' }}
        >
          TRUSTED BY OUR CLIENTS
        </p>
      </div>

      {/* Infinite Logo Marquee Carousel */}
      <div className="client-marquee-container relative w-full overflow-hidden">
        {/* Ambient Left & Right Lateral Vignettes for smooth infinite edge blending */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 sm:w-28 md:w-36 bg-gradient-to-r from-[#060B1F] via-[#060B1F]/90 to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 sm:w-28 md:w-36 bg-gradient-to-l from-[#060B1F] via-[#060B1F]/90 to-transparent z-10" />

        {/* Continuously Moving CSS Track */}
        <div className="client-marquee-track flex items-center gap-6 sm:gap-8 py-2">
          {marqueeItems.map((client, idx) => (
            <div
              key={`${client.id}-${idx}`}
              className="group flex items-center gap-3.5 sm:gap-4 px-5 sm:px-6 py-2.5 sm:py-3 rounded-2xl bg-white/[0.03] hover:bg-white/[0.07] border border-white/[0.08] hover:border-[#7C4DFF]/40 transition-all duration-300 shadow-sm hover:shadow-[0_0_20px_rgba(124,77,255,0.2)] hover:-translate-y-0.5 shrink-0 select-none"
            >
              {/* Client Logo with crisp background to preserve contrast */}
              <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-white/95 p-1.5 flex items-center justify-center shrink-0 shadow-sm border border-white/20 overflow-hidden">
                <img
                  src={client.logo}
                  alt={`${client.name} logo`}
                  className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* Company Name */}
              <span
                className="text-sm sm:text-base font-bold text-slate-200 tracking-wide whitespace-nowrap group-hover:text-white transition-colors"
                style={{ fontFamily: '"Space Grotesk", sans-serif' }}
              >
                {client.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(OurClients);

